// extracted by mini-css-extract-plugin
module.exports = {"section":"Section-module--section--3hce-","fullHeight":"Section-module--fullHeight--TzSJQ"};